var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAureconLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 350,
    viewBox: "0 0 251 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.032 6.58614C116.032 49.9113 116.565 65.4283 99.804 82.8706C93.2574 89.202 85.1368 93.5989 76.3158 95.5883C67.4949 97.5778 58.3073 97.0844 49.7415 94.1615C44.2965 92.1919 39.3645 88.987 35.3198 84.7901C18.8475 67.6219 20.7726 37.7737 37.3263 20.5737C58.0435 -1.01876 85.9214 0.00773827 116.019 0.00773827L116.032 6.58614Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.164 115.673H133.688C94.2727 115.673 57.8984 127.811 31.6005 154.695C12.0274 175.676 0.7991 203.289 0.0857581 232.197C-0.028586 234.159 -0.028586 236.126 0.0857581 238.087C-0.237287 268.305 11.0335 297.462 31.5064 319.37C41.3158 329.163 52.9562 336.859 65.7398 342.002C78.5234 347.145 92.1909 349.631 105.935 349.314H112.676C138.342 349.27 163.321 340.882 183.964 325.375C204.45 336.954 227.564 342.868 251 342.531V341.9C231.882 318.803 230.245 286.602 230.245 262.772L230.164 115.673ZM151.533 265.755C144.987 272.089 136.865 276.488 128.043 278.477C119.22 280.467 110.031 279.972 101.465 277.046C96.0215 275.08 91.0911 271.877 87.0492 267.681C70.5763 250.513 72.502 220.658 89.0557 203.464C109.772 181.865 137.651 182.898 167.749 182.898L167.767 189.484C167.767 232.803 168.294 248.319 151.534 265.755H151.533Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureconLogoGrey);
export default __webpack_public_path__ + "static/media/aurecon_logo_grey.faec53503bed6155bf3d05d0fd6a8c54.svg";
export { ForwardRef as ReactComponent };